<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row no-gutters>
        <v-col
          v-for="(item, i) in filteredCategories"
          :key="i"
          class="py-6 px-md-6"
          cols="12"
          md="6"
        >
          <!-- <div class="rowinfo"> -->
          <cat-card :item="item">
            <template>
              <help-info
                :element-name="`${serviceName}-${componentName}-catBusinessShop-${item.route}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="`${item.name}`"
                :style="{
                  opacity: item.comingSoon ? 0.2 : 1,
                  'pointer-events': item.comingSoon ? 'none' : 'auto',
                  top: '46%',
                  boxShadow: 'none',
                  left: '4%',
                  position: 'relative',
                }"
              />
            </template>
          </cat-card>
          <!-- </div> -->
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import CatCard from "./catCard";

export default {
  name: "catCoOrgan",

  components: { CatCard },

  data: () => ({
    serviceName: "Qrland",
    componentName: "catCoOrgan",
    helpData: [],
  }),
  computed: {
    categories() {
      return [
        {
          name: this.$t("categories.product_introduction"),
          value: "",
          route: "qr.product.shop",
          colors: ["#09122C", "#BE3144", "#872341"],
          icon: "mdi-archive-check",
        },
        {
          name: "معرفی محصول پرو",
          value: "",
          route: "qr.product.productPro",
          colors: ["#490101", "#C9A44F", "#750404"],
          icon: "mdi-professional-hexagon",
        },
        {
          name: this.$t("categories.product_label"),
          value: "",
          route: "qr.product.label",
          colors: ["#220E24", "#5454C5", "#342056"],
          icon: "mdi-tag-multiple",
        },
        {
          name: this.$t("categories.gold_label"),
          value: "goldlabel",
          route: "qr.gold.label",
          colors: ["#957541", "#FCCF5B", "#BE9639"],
          icon: "mdi-gold",
          isTest: false,
        },
        {
            name: "لیبل قیمت",
            value: "pricelabel",
            route: "qr.price.label",
            colors: ["#423E03", "#B5A707", "#F4CE46"],
            icon: "mdi-cash-multiple",
          },
           {
            name: "حضور و غیاب",
            value: "attendanceqr",
            route: "qr.attendance",
            icon: "mdi-account-check",
            colors: ["#0284C7", "#10B981", "#D1FAE5"],
            permission: "qrAdmin_access", 
          },

        {
          name: this.$t("categories.franchise"),
          value: "",
          route: "qr.link",
          colors: ["#0093E9", "#80D0C7", "#0093E9"],
          icon: "mdi-assistant",
          comingSoon: true,
        },
        {
          name: this.$t("categories.marketplace"),
          value: "",
          route: "qr.link",
          colors: ["#93291E", "#ED213A", "#93291E"],
          icon: "mdi-store-marker",
          comingSoon: true,
        },
        {
          name: this.$t("categories.recruitment_form"),
          value: "",
          route: "qr.link",
          colors: ["#e43a15", "#e65245", "#e43a15"],
          icon: "mdi-list-box-outline",
          comingSoon: true,
        },
        {
          name: this.$t("categories.organizational_form"),
          value: "",
          route: "qr.link",
          colors: ["#2c3e50", "#2980b9", "#2c3e50"],
          icon: "mdi-form-textarea",
          comingSoon: true,
        },
        {
          name: this.$t("categories.employee_card"),
          value: "",
          route: "qr.link",
          colors: ["#FF8008", "#FFC837", "#FF8008"],
          icon: "mdi-card-account-phone-outline",
          comingSoon: true,
        },
        {
          name: this.$t("categories.book_magazine"),
          value: "",
          route: "qr.link",
          colors: ["#0093E9", "#80D0C7", "#0093E9"],
          icon: "mdi-book-open-blank-variant",
          comingSoon: true,
        },
        {
          name: this.$t("categories.catalog_brochure"),
          value: "",
          route: "qr.notebook",
          colors: ["#93291E", "#ED213A", "#93291E"],
          icon: "mdi-notebook",
          comingSoon: true,
        },
      ];
    },
filteredCategories() {
 const list = this.categories.filter((cat) => {
        if (cat.route === "qr.attendance") {
          return this.ribbon_can("qrAdmin_access");
        }
        return true;
      });

      const currentLocale = this.$i18n.locale;
      if (currentLocale === "fa") {
        return list;
      }
      return list.map((x) => ({
        ...x,
        comingSoon: true,
      }));
    },
      },

  watch: {
    "$i18n.locale": {
      handler(newLocale) {
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
};
</script>

<style scoped></style>
